import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

import * as Cesium from 'cesium';
// 将 Cesium 挂载到全局 window 对象上
(window as any).Cesium = Cesium;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
